<template>
	<section class="Section">
            <div class="Container WhiteBox">
                <div class="BoxWide">
                    <div class="Bookmark"><span>{{ this.entita ? this.entita.Descrizione : "" }}</span> <i>{{ this.entita ? this.entita.CodiceEntita : "" }}</i></div>
                </div>
                <div class="BoxWide"><div class="WhiteSpace">&nbsp;</div></div>
                <div class="BoxWide">
                    <div class="MainDataBox">
                        <div class="MainDataImage"><span><i><img :src='this.imgUrl' alt=""/></i></span></div>
                        <div class="MainDataInfo">
                            <ul>
                                <li><span>Identificativo</span>{{ this.entita ? this.entita.Identificativo : "" }}</li>
                                <li><span>Descrizione</span>{{ this.entita ? this.entita.Descrizione : "" }}</li>
                                <li><span>Marca</span>{{ this.entita ? this.entita.Marca : "" }}</li>
                                <li><span>Modello</span>{{ this.entita ? this.entita.Modello : "" }}</li>
                                <li><span>Matricola</span>{{ this.entita ? this.entita.Matricola : "" }}</li>
                                <li><span>Famiglia</span>{{this.entita ? this.entita.CodiceFamiglia: " "}}</li>
                            </ul>
                            <ul>
                                <li><span>Sito</span>{{ this.entita ? this.entita.DescrSito : "" }}</li>
                                <li><span>Indirizzo</span>{{ this.entita ? this.entita.IndirSito : "" }}</li>
                                <li><span>Unita</span>{{ this.entita ? this.entita.DescrUnita : "" }}</li>
                                <li><span>Reparto</span>{{ this.entita ? this.entita.DescrReparto : "" }}</li>
                                <li><span>Comparto</span>{{ this.entita ? this.entita.DescrComparto : "" }}</li>  
                                <li><span>Sotto Famiglia</span>{{this.entita ? this.entita.CodiceSottoFamiglia : "" }} </li>                        
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="BoxWide"><div class="WhiteSpace">&nbsp;</div></div>
            </div>
        </section>
        <GrigliaParti :listaParti="this.listaParti"></GrigliaParti>
        <GrigliaPianoDiManutenzione :listaPianoDiManutenzione ="this.listaPianoDiManutenzione"> </GrigliaPianoDiManutenzione>
        <GirigliaStoricoInterveni :listaStoricoInterventiManutenzione ="this.listaStoricoInterventiManutenzione"></GirigliaStoricoInterveni>
</template>

<script>


import GrigliaParti from "@/components/GrigliaParti.vue"
import GrigliaPianoDiManutenzione from "@/components/GrigliaPianoDiManutenzione.vue"
import GirigliaStoricoInterveni from "@/components/GrigliaStoricoIntEntita.vue"

import { apiMixin } from "/mixin.js"
import Entita from "@/models/entita.model.js"
import PianoManutenzione from "@/models/pianoManutenzione.model.js"
import Parte from "@/models/parte.model.js"
import StoricoInterventoEntita from "@/models/storicoInterventoEntita.model.js"

export default {
    name: "SchedaEntita",
    mixins:[apiMixin],

    data(){       
        return{
            listaParti:[],
            listaPianoDiManutenzione:[],
            listaStoricoInterventiManutenzione:[],   
            entita: null,     
            imgUrl: null,
        }
    },
    
    components: {
        GrigliaParti,
        GrigliaPianoDiManutenzione,
        GirigliaStoricoInterveni
    },

    created(){
        this.getEntita();
        this.getPianoDiManutenzione();
        this.getParti();
        this.getStoricoInterventi();
    },

    methods:{ 

        getEntita(){
                this.doApiCall("get", "entita/GetEntitaWeb?key="+this.$route.params.idEntita, this.$store.getters.getUtente.Token)
                .then(
                    (data) => {                
                        if(data){                     
                            this.entita = Object.assign(new Entita(), data);
                            return this.entita                                                                              
                        }
                    }
                )
                .then(
                    (entita) => {                                                   
                        this.doApiCall("getImg", "immagini/GetImg?sysChiaveglobale="+entita.SysChiaveglobale, this.$store.getters.getUtente.Token)
                        .then(
                            (data) => {                                                                  
                                if(data){     
                                    this.imgUrl = URL.createObjectURL(data);                                                                                               
                                    return this.imgUrl;                                                                                                                                                     
                                }
                            }
                        )                      
                    }
                );                     
            },

        getPianoDiManutenzione(){
            this.doApiCall("get", "entita/GetPianoManut?idEntita="+this.$route.params.idEntita, this.$store.getters.getUtente.Token).then(
                (data) => {                
                    if(data){                     
                        this.listaPianoDiManutenzione = data.map(o =>{
                            return Object.assign(new PianoManutenzione(), o);    
                        })           
                    }
                }
            );
        },

        getParti(){
            this.doApiCall("get", "entita/GetParti?idEntita="+this.$route.params.idEntita, this.$store.getters.getUtente.Token).then(
                (data) => {                
                    if(data){                     
                        this.listaParti = data.map(o =>{
                            return Object.assign(new Parte(), o);    
                        }) 
                    }
                }
            );
        },

        getStoricoInterventi(){
            this.doApiCall("get", "entita/GetStoricoAttivita?idEntita="+this.$route.params.idEntita, this.$store.getters.getUtente.Token).then(
                (data) => {                
                    if(data){                     
                        this.listaStoricoInterventiManutenzione = data.map(o =>{
                            return Object.assign(new StoricoInterventoEntita(), o);    
                        })           
                    }
                }
            );
        },       
    }
}
</script>
